import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './greetings.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var Greetings = /** @class */ (function (_super) {
    tslib_1.__extends(Greetings, _super);
    function Greetings(element) {
        return _super.call(this, element) || this;
    }
    Greetings.prototype.init = function () {
        this.containerSlider = this.element.querySelector('.greetings__swiper');
        this.slider = new Swiper(this.containerSlider, {
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
                stopOnLastSlide: true,
            },
            crossFade: true,
            effect: 'fade',
            centeredSlides: false,
            spaceBetween: 0,
            initialSlide: 0,
            freeMode: false
        });
        this.slider.on('slideChange', function () {
        });
    };
    Greetings.prototype.bindEvents = function () {
    };
    return Greetings;
}(Base));
export { Greetings };



//////////////////
// WEBPACK FOOTER
// ./components/greetings/greetings.component.ts
// module id = 746
// module chunks = 0